var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppleOriginal = function SvgAppleOriginal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.496 14.883c-.465 1-.687 1.448-1.286 2.332-.833 1.233-2.01 2.77-3.466 2.783-1.295.013-1.628-.819-3.385-.809-1.758.01-2.124.826-3.419.813-1.457-.012-2.571-1.4-3.405-2.636C1.202 13.913.96 9.863 2.398 7.709 3.42 6.18 5.033 5.283 6.55 5.283c1.543 0 2.515.823 3.792.823 1.238 0 1.993-.824 3.78-.824 1.349 0 2.778.714 3.798 1.949-3.339 1.778-2.796 6.412.576 7.652M12.955 3.122c.649-.81 1.14-1.951.961-3.12-1.06.07-2.299.725-3.021 1.58-.657.775-1.2 1.925-.99 3.044 1.157.035 2.354-.638 3.05-1.504"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppleOriginal);
export { ForwardRef as ReactComponent };